class Checkbox extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();
    const activeStyle = this.getAttribute("active-style");

    this.checkboxItems = this.shadowRoot.querySelector('slot')?.assignedElements();
    if (this.checkboxItems?.length === 1) {
      this.checkboxItems = Array.from(this.checkboxItems?.[0]?.children);
    }
    this.checkboxItems?.map(el => {
      el?.addEventListener("x-checkbox-item-change", ({ detail }) => {
        if (detail?.checked === true) {
          el.setAttribute("active", activeStyle);
        } else {
          el.removeAttribute("active");
        }
      })
    })
  }

  static get observedAttributes() {
    return ["active-style"]
  }

  attributeChangedCallback(name, oldValue, newValue) {
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  css() {
    return `
      :host {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      :host > div {
        width: 100%;
        height: 100%;
      }
    `;
  }

  template() {
    return `
      <div>
        <slot></slot>
      </div>
    `;
  }
}

class CheckboxItem extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();

    this.inputElement = this.shadowRoot.querySelector("input");
    this.rootElement = this.shadowRoot.querySelector("div");

    this.inputElement.addEventListener("change", ({ target }) => {
      this.dispatchEvent(new CustomEvent("x-checkbox-item-change", {
        bubbles: true,
        cancelable: true,
        detail: {
          checked: target.checked
        }
      }))
    })
  }

  static get observedAttributes() {
    return ['active']
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this[name] = newValue;
  }

  set active(val) {
    if (val) {
      this.rootElement.setAttribute("style", val);
    } else {
      this.rootElement.removeAttribute("style");
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  css() {
    return `
      :host {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      :host > label {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
    `;
  }

  template() {
    return `
      <label>
        <input type='checkbox' hidden />
        <div>
          <slot></slot>
        </div>
      </label>
    `;
  }
}

customElements.define("x-checkbox", Checkbox);
customElements.define("x-checkbox-item", CheckboxItem);